/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_What_P1Inputs */

const en_wc_what_p1 = /** @type {(inputs: Wc_What_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft is a free, open-source word processor for creating and editing documents. Its familiar ribbon brings text formatting, styles, tables and review tools into one workspace, with .docx support for exchanging files with Microsoft Word.`)
};

/**
* | output |
* | --- |
* | "WordCraft is a free, open-source word processor for creating and editing documents. Its familiar ribbon brings text formatting, styles, tables and review too..." |
*
* @param {Wc_What_P1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_what_p1 = /** @type {((inputs?: Wc_What_P1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_What_P1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_what_p1(inputs)
});
export { wc_what_p1 as "wc.what.p1" }